import { companyInfo } from "../data/services";

const DEFAULT_TITLE = "精装入场查验与工程质量过程管控｜江苏道鼎升工程检测";
const DEFAULT_DESCRIPTION =
  "江苏道鼎升工程检测有限公司面向开发商、建设单位、物业单位和住宅交付项目，提供精装入场查验、过程质量巡检、分户查验、一房一验、交付前预验收、整改复查和工程质量检测服务。";
const DEFAULT_IMAGE = "/img/logo.png";
const STRUCTURED_DATA_ID = "structured-data";

function getOrigin() {
  if (typeof window === "undefined") {
    return "";
  }
  return window.location.origin;
}

export function absoluteUrl(path) {
  if (!path) {
    return getOrigin() + "/";
  }
  if (/^https?:\/\//.test(path)) {
    return path;
  }
  const normalizedPath = path.charAt(0) === "/" ? path : "/" + path;
  return getOrigin() + normalizedPath;
}

function upsertMeta(attribute, key, content) {
  if (typeof document === "undefined" || !content) {
    return;
  }

  let tag = document.head.querySelector("meta[" + attribute + "='" + key + "']");
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute(attribute, key);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
}

function setCanonical(url) {
  if (typeof document === "undefined" || !url) {
    return;
  }

  let tag = document.head.querySelector("link[rel='canonical']");
  if (!tag) {
    tag = document.createElement("link");
    tag.setAttribute("rel", "canonical");
    document.head.appendChild(tag);
  }
  tag.setAttribute("href", url);
}

export function setSeo(options = {}) {
  if (typeof document === "undefined") {
    return;
  }

  const title = options.title || DEFAULT_TITLE;
  const description = options.description || DEFAULT_DESCRIPTION;
  const canonical = options.canonical || absoluteUrl(options.path || window.location.pathname);
  const image = absoluteUrl(options.image || DEFAULT_IMAGE);
  const type = options.type || "website";

  document.title = title;
  upsertMeta("name", "description", description);
  upsertMeta("name", "robots", options.robots || "index,follow");
  upsertMeta("property", "og:title", title);
  upsertMeta("property", "og:description", description);
  upsertMeta("property", "og:type", type);
  upsertMeta("property", "og:url", canonical);
  upsertMeta("property", "og:image", image);
  upsertMeta("property", "og:site_name", companyInfo.name);
  upsertMeta("name", "twitter:card", "summary_large_image");
  upsertMeta("name", "twitter:title", title);
  upsertMeta("name", "twitter:description", description);
  upsertMeta("name", "twitter:image", image);
  setCanonical(canonical);
}

export function clearStructuredData() {
  if (typeof document === "undefined") {
    return;
  }

  const script = document.getElementById(STRUCTURED_DATA_ID);
  if (script) {
    script.parentNode.removeChild(script);
  }
}

export function setStructuredData(graph) {
  if (typeof document === "undefined") {
    return;
  }

  const data = Array.isArray(graph)
    ? {
        "@context": "https://schema.org",
        "@graph": graph
      }
    : graph;

  let script = document.getElementById(STRUCTURED_DATA_ID);
  if (!script) {
    script = document.createElement("script");
    script.id = STRUCTURED_DATA_ID;
    script.type = "application/ld+json";
    document.head.appendChild(script);
  }
  script.textContent = JSON.stringify(data);
}

export function organizationSchema() {
  return {
    "@type": "Organization",
    "@id": absoluteUrl("/#organization"),
    name: companyInfo.name,
    alternateName: companyInfo.shortName,
    url: absoluteUrl("/"),
    logo: absoluteUrl("/img/logo.png"),
    email: companyInfo.email,
    telephone: companyInfo.phone,
    areaServed: companyInfo.serviceArea,
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "法定代表人",
        value: companyInfo.legalRepresentative
      }
    ]
  };
}

export function localBusinessSchema() {
  return {
    "@type": "LocalBusiness",
    "@id": absoluteUrl("/#localbusiness"),
    name: companyInfo.name,
    legalName: companyInfo.name,
    url: absoluteUrl("/"),
    image: absoluteUrl("/img/logo.png"),
    email: companyInfo.email,
    telephone: companyInfo.phone,
    address: {
      "@type": "PostalAddress",
      streetAddress: companyInfo.address,
      addressLocality: "苏州市",
      addressRegion: "江苏省",
      addressCountry: "CN"
    },
    areaServed: companyInfo.serviceArea,
    additionalProperty: [
      {
        "@type": "PropertyValue",
        name: "法定代表人",
        value: companyInfo.legalRepresentative
      }
    ]
  };
}

export function websiteSchema() {
  return {
    "@type": "WebSite",
    "@id": absoluteUrl("/#website"),
    name: companyInfo.name,
    alternateName: companyInfo.shortName,
    url: absoluteUrl("/"),
    publisher: {
      "@id": absoluteUrl("/#organization")
    },
    inLanguage: "zh-CN"
  };
}

export function faqSchema(faqs) {
  return {
    "@type": "FAQPage",
    mainEntity: faqs.map(function(item) {
      return {
        "@type": "Question",
        name: item.question,
        acceptedAnswer: {
          "@type": "Answer",
          text: item.answer
        }
      };
    })
  };
}

export function breadcrumbSchema(items) {
  return {
    "@type": "BreadcrumbList",
    itemListElement: items.map(function(item, index) {
      return {
        "@type": "ListItem",
        position: index + 1,
        name: item.name,
        item: absoluteUrl(item.path)
      };
    })
  };
}
